import { SectionHero } from './SectionHero';
import { SectionTrailers } from './SectionTrailers';
// import { SectionInnovators } from './SectionInnovators';
import { SectionTheorists } from './SectionTheorists';
import { Section } from './Section';

/**
 * SectionFactory class
 * Creates appropriate section instances based on section index
 */
export class SectionFactory {
  /**
   * Create a section instance based on section data
   * @param {Object} sectionData - Section data from SectionManager
   * @returns {Section} - Section instance
   */
  static createSection(sectionData) {
    // Create appropriate section based on index
    switch (sectionData.index) {
      case 0:
        return new SectionHero(sectionData);
      case 1:
        return new SectionTrailers(sectionData);
      // case 2:
      //   return new SectionInnovators(sectionData);
      case 2:
        return new SectionTheorists(sectionData);
      default:
        return new Section(sectionData);
    }
  }
} 